import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Tooltip,
  Paper,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const DiscountRuleTable = ({ data, onEdit, onDelete }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Auto</TableCell>
            <TableCell>Coupon</TableCell>
            <TableCell>Enabled</TableCell>
            <TableCell>Start</TableCell>
            <TableCell>End</TableCell>
            <TableCell>Priority</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((rule) => (
            <TableRow key={rule._id}>
              <TableCell>{rule.name}</TableCell>
              <TableCell>{rule.type}</TableCell>
              <TableCell>
                {rule.autoApply ? <Chip label="Auto" size="small" /> : "—"}
              </TableCell>
              <TableCell>{rule.couponCode || "—"}</TableCell>
              <TableCell>
                {rule.enabled ? (
                  <Chip label="Enabled" color="success" size="small" />
                ) : (
                  <Chip label="Disabled" color="default" size="small" />
                )}
              </TableCell>
              <TableCell>
                {rule.conditions?.startDate
                  ? new Date(rule.conditions.startDate).toLocaleDateString()
                  : "—"}
              </TableCell>
              <TableCell>
                {rule.conditions?.endDate
                  ? new Date(rule.conditions.endDate).toLocaleDateString()
                  : "—"}
              </TableCell>
              <TableCell>{rule.stacking?.priority ?? 0}</TableCell>
              <TableCell align="right">
                <Tooltip title="Edit">
                  <IconButton onClick={() => onEdit(rule)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton onClick={() => onDelete(rule._id)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DiscountRuleTable;
